// extracted by mini-css-extract-plugin
export default {"header":"Jl9L7CViIxhKN_jDG4QL7","logoContainer":"ThhhrP5wi5a-SwK8gAwwf","title":"gbaBJIKha5wQ7cq2gRPWV","userContainer":"_1PLp_f9Wf-rCFruD6wAE4e"};